export enum StudentBtnSizeOption {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}
